import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NodeConfigurationDTO } from 'src/app/model/configuration/node-configuration-dto';
import { ParserLearningConfig } from '../node-lifecycle.component';

@Component({
  selector: 'app-node-lifecycle-parser-modal',
  templateUrl: './node-lifecycle-parser-modal.component.html',
  styleUrl: './node-lifecycle-parser-modal.component.scss'
})
export class NodeLifecycleParserModalComponent {
  public selectedConfiguration: ParserLearningConfig | undefined

  constructor(
    @Inject(MAT_DIALOG_DATA) public nodeConfiguration: NodeConfigurationDTO,
    public dialogRef: MatDialogRef<NodeLifecycleParserModalComponent>
  ) {
    this.selectedConfiguration = {
      timeLimitHours: 1,
      timeLimitHoursWithoutFeatures: 1,
      variables: {}
    }

    if(this.nodeConfiguration){
      let vars: {[dataSource: string]: string[]} = {}
      
      nodeConfiguration.dataSources.forEach(ds => {
        vars[ds.name] = ds.configuration.variables.map(x => x.name)
        ds.configuration.variables.forEach(u => u.selected = true)
      })

      this.selectedConfiguration = {
        timeLimitHours: 1,
        timeLimitHoursWithoutFeatures: 1,
        variables: vars
      }
    }
  }

  execute(): void {
    if(!!this.selectedConfiguration){
      this.selectedConfiguration.variables = {}

      this.nodeConfiguration.dataSources.forEach(ds => {
        this.selectedConfiguration!.variables[ds.name] = ds.configuration.variables.filter(x => x.selected === true).map(u => u.name)
      })

      this.dialogRef.close(this.selectedConfiguration)
    }
  }
}